import { getJson } from '../helpers/strapi';
import { IBlog } from '../types/index';

export function getDataUrls(slug: string, published: undefined | 'draft' | 'published'): string[] {
  return [`${process.env.GATSBY_API_URL}/blogs/${slug}${published ? '/' + published : ''}`];
}

export async function fetchData(slug: string, published: undefined | 'draft' | 'published'): Promise<IBlog> {
  return getJson<IBlog>(`/blogs/${slug}${published ? '/' + published : ''}`);
}

export async function fetchAllBlogs(): Promise<IBlog[]> {
  return getJson<IBlog[]>('/blogs/published?_limit=-1');
}
